var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "brick-circle-base",
    {
      staticClass: "journey-brick",
      class: [_vm.isActive ? "active" : "undefined", _vm.brickTypeName],
      on: {
        mouseup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "left", 37, $event.key, [
              "Left",
              "ArrowLeft"
            ])
          ) {
            return null
          }
          if ("button" in $event && $event.button !== 0) {
            return null
          }
          return _vm.openSettings(_vm.tabs.generalSettings)
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "sub settings",
          class: [_vm.isActive ? "active" : "undefined", _vm.brickTypeName],
          on: {
            mouseup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "left", 37, $event.key, [
                  "Left",
                  "ArrowLeft"
                ])
              ) {
                return null
              }
              if ("button" in $event && $event.button !== 0) {
                return null
              }
              return _vm.openSettings(_vm.tabs.generalSettings)
            }
          }
        },
        [
          _c("i", { staticClass: "fas fa-cog" }),
          _vm._v(" "),
          _c("a", { staticClass: "title" }, [
            _vm._v(
              _vm._s(
                _vm.resource(
                  "JourneyBuilder_JourneyBrickMenu_Settings_DisplayName"
                )
              )
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sub deduplicate",
          class: [_vm.isDeduplicationActive ? "active" : "undefined"],
          on: {
            mouseup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "left", 37, $event.key, [
                  "Left",
                  "ArrowLeft"
                ])
              ) {
                return null
              }
              if ("button" in $event && $event.button !== 0) {
                return null
              }
              return _vm.openSettings(_vm.tabs.deduplicationSettings)
            }
          }
        },
        [
          _c("i", { staticClass: "fas fa-clone" }),
          _vm._v(" "),
          _c("a", { staticClass: "title" }, [
            _vm._v(
              _vm._s(
                _vm.resource(
                  "JourneyBuilder_JourneyBrickMenu_Deduplicate_DisplayName"
                )
              )
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sub delay",
          class: [_vm.isDelayed ? "active" : "undefined"],
          on: {
            mouseup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "left", 37, $event.key, [
                  "Left",
                  "ArrowLeft"
                ])
              ) {
                return null
              }
              if ("button" in $event && $event.button !== 0) {
                return null
              }
              return _vm.openSettings(_vm.tabs.generalSettings)
            }
          }
        },
        [
          _c("i", { staticClass: "fas fa-clock" }),
          _vm._v(" "),
          _c("a", { staticClass: "title" }, [
            _vm._v(
              _vm._s(
                _vm.resource(
                  "JourneyBuilder_JourneyBrickMenu_Delay_DisplayName"
                )
              )
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "brick-icon" }, [
        _c("i", { staticClass: "fas fa-magic" })
      ]),
      _vm._v(" "),
      _c("journey-connection-settings", {
        ref: "settings",
        attrs: {
          connection: _vm.connection,
          "available-conditions": _vm.config.availableConditions
        },
        on: {
          closed: function($event) {
            _vm.settingsOpen = false
          },
          save: function($event) {
            return _vm.$emit("change-connection", $event)
          },
          delete: function($event) {
            return _vm.$emit("delete-connection", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }